import DefaultIcon from '@rover/react-lib/src/pages/training/components/TrainerFlair/icons/DefaultIcon.svg';
import FlameIcon from '@rover/react-lib/src/pages/training/components/TrainerFlair/icons/FlameIcon.svg';
import { TrainerFlairSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/trainerFlairSlugEnum';
import { Logger } from '@rover/rsdk/src/modules/Logging';
import type SVG from '@rover/types/src/SVG';

const DEFAULT_FLAIR_ICON = DefaultIcon;

const FLAIR_ICON_MAP: Record<TrainerFlairSlugEnum, SVG> = {
  'trainer-flair-popular': FlameIcon,
};

export function getFlairIconBySlug(flairSlug: TrainerFlairSlugEnum): SVG {
  const icon = FLAIR_ICON_MAP[flairSlug];
  if (!icon) {
    Logger.warn(`No icon found for trainer flair slug: ${flairSlug}`);
    return DEFAULT_FLAIR_ICON;
  }

  return icon;
}
